import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticles = getFeaturedArticles().slice(0, 3);

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20deep%20navy%20and%20soft%20warm%20gold%20gradients%2C%20flowing%20curved%20shapes%20intersecting%20like%20digital%20pathways%2C%20modern%20minimalist%20tech%20aesthetic%2C%20smooth%20gradient%20transitions%2C%20elegant%20atmospheric%20lighting%2C%20no%20text%2C%20clean%20abstract%20design&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="蓝色导航发布页背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full text-primary-200 text-sm font-medium whitespace-nowrap">
            专业内容发布与导航平台
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-6">
          让每一次发布都
          <span className="text-primary-300">精准触达</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          蓝色导航发布页是您一站式内容发布与网站导航的首选平台，提供高效便捷的发布管理工具，帮助用户快速完成内容上线、链接归类与流量导引。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zixun-meiti"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium transition-all duration-300 whitespace-nowrap"
          >
            开始探索导航
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/20 text-background-50 rounded-lg text-base font-medium transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50/8 backdrop-blur-sm border border-background-50/10 rounded-lg p-4 text-left hover:bg-background-50/15 transition-all duration-300"
            >
              <span className="block text-xs text-accent-400 mb-2 whitespace-nowrap">{article.categoryName}</span>
              <h3 className="text-sm font-medium text-background-50 group-hover:text-primary-300 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <span className="block text-xs text-background-50/40 mt-2 whitespace-nowrap">{article.publishDate}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}